import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deletePartnerWhiteLabel } from '../service';
import {
  DELETE_PARTNER_WHITE_LABEL,
  DELETE_PARTNER_WHITE_LABEL_PENDING,
  DELETE_PARTNER_WHITE_LABEL_SUCCESS,
  DELETE_PARTNER_WHITE_LABEL_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'

function* sagaDeletePartnerWhiteLabel(action) {
  yield put({ type: DELETE_PARTNER_WHITE_LABEL_PENDING, id: action.id })

  try {
    const a = yield call(deletePartnerWhiteLabel, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_PARTNER_WHITE_LABEL_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_PARTNER_WHITE_LABEL_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeletePartnerWhiteLabel() {
  yield takeLatest(DELETE_PARTNER_WHITE_LABEL, sagaDeletePartnerWhiteLabel)
}
